<template>
  <header class="site-header">
    <div class="container bar">
      <router-link to="/" class="brand" aria-label="Citron Digital, accueil" @click="open = false">
        <img src="/img/citron-icon.webp" width="40" height="39" alt="" decoding="async">
        <span class="brand-name">Citron Digital</span>
      </router-link>

      <button class="menu-toggle" type="button" aria-controls="navigation-principale" :aria-expanded="open ? 'true' : 'false'" @click="open = !open">
        <span class="visually-hidden">{{ open ? 'Fermer le menu' : 'Ouvrir le menu' }}</span>
        <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <path v-if="!open" d="M3 6h18M3 12h18M3 18h18" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" fill="none"/>
          <path v-else d="M5 5l14 14M19 5L5 19" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" fill="none"/>
        </svg>
      </button>

      <nav id="navigation-principale" class="nav" :class="{open}" aria-label="Navigation principale">
        <ul>
          <li v-for="link in links" :key="link.path">
            <router-link :to="link.path" active-class="" exact-active-class="router-link-active" @click="open = false">{{ link.name }}</router-link>
          </li>
        </ul>
        <a class="btn btn--primary cta" :href="productUrl" rel="noopener">Accéder au gestionnaire</a>
      </nav>
    </div>
  </header>
</template>

<script>
  import site from "@/content/site";

  export default {
    name: 'SiteHeader',
    data() {
      return {
        open: false,
        productUrl: site.productUrl,
        links: [
          {name: 'Logiciel', path: '/gestionnaire-citron'},
          {name: 'Facturation électronique', path: '/gestionnaire-citron/facturation-electronique'},
          {name: 'Blog', path: '/blog'},
          {name: 'Création de site', path: '/site-web'},
          {name: 'À propos', path: '/portfolio'},
          {name: 'Contact', path: '/contact'},
        ],
      }
    },
    watch: {
      '$route.path'() {
        this.open = false;
      }
    },
  }
</script>

<style lang="stylus" scoped>
@import '~/src/common/style/constants.styl';

.site-header
  position sticky
  top 0
  z-index 50
  background rgba(243, 246, 238, 0.96)
  border-bottom 1px solid RULE
  @supports (backdrop-filter: blur(8px))
    background rgba(243, 246, 238, 0.86)
    backdrop-filter blur(10px)

// Le menu en ligne demande environ 1080px : en dessous, on garde le bouton de menu
NAV_SIZE = 1200px

.bar
  display flex
  align-items center
  justify-content space-between
  gap 12px
  min-height 68px

.brand
  display inline-flex
  flex none
  align-items center
  gap 10px
  text-decoration none
  white-space nowrap
  &:hover
    background none
  img
    width 40px
    height 39px
  .brand-name
    font-family 'Calder-LC', 'Trebuchet MS', system-ui, sans-serif
    font-size 1.3rem
    letter-spacing -0.01em
    color INK

.menu-toggle
  display inline-flex
  align-items center
  justify-content center
  width 48px
  height 48px
  border 2px solid INK
  border-radius 6px
  background transparent
  color INK
  cursor pointer

.nav
  display none
  ul
    list-style none
    margin 0
    padding 0
  li
    margin 0
    padding 0
  a:not(.btn)
    display block
    padding 12px 4px
    font-weight 600
    font-size 1rem
    text-decoration none
    &:hover
      background none
      text-decoration underline
      text-decoration-color LEMON_DEEP
    &.router-link-active
      text-decoration underline
      text-decoration-color LEMON_DEEP
      text-decoration-thickness 3px
  &.open
    display block
    position absolute
    left 0
    right 0
    top 100%
    padding 8px clamp(16px, 4vw, 32px) 20px
    background PAPER
    border-bottom 1px solid RULE
    box-shadow 0 14px 24px -16px rgba(18, 32, 74, 0.35)
    .cta
      margin-top 8px
      width 100%

@media (min-width: NAV_SIZE)
  .menu-toggle
    display none
  // .nav.open reste plus spécifique que .nav : on le remet à plat si la fenêtre s'agrandit menu ouvert
  .nav, .nav.open
    display flex
    position static
    align-items center
    gap 16px
    padding 0
    background none
    border-bottom 0
    box-shadow none
    ul
      display flex
      align-items center
      gap 14px
    li
      white-space nowrap
    a:not(.btn)
      padding 6px 2px
      font-size 0.98rem
    .cta
      flex none
      width auto
      margin-top 0
      min-height 42px
      padding 0 14px
      font-size 0.95rem
      white-space nowrap
</style>
